module.exports = __webpack_public_path__ + "img/yanbao_yousejinshu_head.4436175a.png";